var $ = require('jquery');
var markerTpl = require('../templates/partials/markerTpl.hbs');

var keyCode = Object.freeze({
  'RETURN': 13,
  'SPACE': 32
});

/**
 * Map pin representing property location.
 * @constructor
 * @param {Object} location - the google.maps.LatLng coordinates of property
 * @param {string} markerIcon - css class name of marker font icon.
 * @param {boolean} isHotelPin - True if the property is a hotel location
 * @extends {google.maps.OverlayView}
 */
var Marker = function(location, markerIcon, isHotelPin){
  this.location = location;
  this.$markerNode = this.getMarkerNode(markerIcon, isHotelPin);
	this.$markerBtn = this.$markerNode.find('[role="button"]');
  this.stopEventPropagation();
};

/**
 * Called automatically from the API when the map's panes are ready and the marker has been added to the map.
 * @return {void}
 */
Marker.prototype.onAdd = function() {
  this.getPanes().overlayMouseTarget.appendChild(this.$markerNode.get(0));
};

/**
 * Called automatically from the API when the marker is removed from the map.
 * @return {void}
 */
Marker.prototype.onRemove = function() {
  this.$markerNode.remove();
};

/**
 * Called automatically from the API when the object is first displayed.
 * @return {void}
 */
Marker.prototype.draw = function() {
  var self = this,
    divPosition = this.getProjection().fromLatLngToDivPixel(self.location);
  this.$markerNode.css("left", (divPosition.x + 'px'));
  this.$markerNode.css("top", (divPosition.y + 'px'));
};

/**
 * Stops clicks/drags events from bubbling up to the map.
 * @return {void}
 */
Marker.prototype.stopEventPropagation = function() {
  var _self = this;
  ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart',
    'pointerdown']
    .forEach(function(event) {
			_self.$markerBtn.on(event, function(e) {
        e.stopPropagation();
      });
    });
};

/**
 * Configure and build marker node
 * @param {string} markerIcon - css class name of marker font icon.
 * @param {boolean} isHotelPin - True if the property is a hotel location
 * @return {Object} jQuery wrapped marker node
 */
Marker.prototype.getMarkerNode = function (markerIcon, isHotelPin) {
  return $(markerTpl({ markerIcon: markerIcon, isHotelPin: isHotelPin}));
};

/**
 * Get nearby attraction details of marker
 * @return {Object} nearby attraction details
 */
Marker.prototype.getDetails = function () {
  return this.nearByDetails || {};
};

/**
 * Map pin representing a nearby featured attraction location.
 * @constructor
 * @param {Object} location - the google.maps.LatLng coordinates of near by attraction
 * @param {Object} markerGroup - object that controls the markers
 * @param {Array} nearByDetails - array of nearby attraction details
 * @param {string} markerIcon - css class name of marker font icon.
 */
var NearbyMarker = function (location, markerGroup, nearByDetails,  markerIcon) {
  Marker.call(this, location,  markerIcon, false);
  this.markerGroup = markerGroup;
  this.nearByDetails = nearByDetails;
	this.$markerBtn.on('click keydown mouseover', this.toggleButtonEventHandler.bind(this));
};

NearbyMarker.prototype = Object.create(Marker.prototype);

/**
 * Toggle state of selected marker
 * @return {void}
 */
NearbyMarker.prototype.toggleButtonEventHandler = function (event) {
  var type = event.type;
  // Grab the keydown, click and mouseover events
  switch (type) {
    case 'keydown':
      if (event.keyCode === keyCode.RETURN || event.keyCode === keyCode.SPACE) {
        this.markerGroup.toggleMarker(this);
      }
      break;
    case 'click':
      this.markerGroup.toggleMarker(this);
      break;
    case 'mouseover':
      if (!this.isActive()) {
        this.markerGroup.toggleMarker(this);
      }
      break;
  }
};

/**
 * Check if marker is selected
 * @return {boolean} indicating the active state of marker
 */
NearbyMarker.prototype.isActive = function () {
	return this.$markerBtn.attr('aria-pressed') === "true";
};

/**
 * Activate selected marker and set set ARIA attribute
 * @return {void}
 */
NearbyMarker.prototype.activate = function () {
	this.$markerBtn.attr("aria-pressed", "true");
	this.$markerBtn.addClass("is-active");
};

/**
 * Clear active marker and set ARIA attribute
 * @return {void}
 */
NearbyMarker.prototype.clear = function () {
	this.$markerBtn.attr("aria-pressed", "false");
	this.$markerBtn.removeClass("is-active");
};

module.exports = {
  createHotelMarker: function (overlayView, location) {
    $.extend( Marker.prototype, overlayView );
		return new Marker(location, 'l-display-inline-block icon t-icon-hotel-pin', true);
  },
  createNearbyMarker: function (overlayView, location, markerGroup, nearByDetails) {
    $.extend( NearbyMarker.prototype, overlayView );
    return new NearbyMarker(location, markerGroup, nearByDetails, 't-icon-location');
  }
};
